import React, { useEffect } from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { CellMeasurerCache } from 'react-virtualized';
import Box from '@material-ui/core/Box';
import FabIcon from '../components/common/fabIcon';
import FeedCard from '../components/feedCard';
import Loader from '../components/common/loader';
import { initFeed } from '../stores/feedStore';
import impressionService from '../services/impressionService';
import { useTablet } from '../hooks/utilHooks';
import NoResultsIcon from '../img/search-results.svg';
import NotFound from './common/notFound';
import NoPosts from './common/noPosts';
import { getPostLanguage } from '../services/authService';
import NullDataFound from './gww/nullDataFound';
import WomenWillDialogBox from './post/womenWillDialogBox';
import FeelingHappy from '../img/feeling-happy.svg';
import { getThirdPartyUser, getSpentTime } from '../services/authService';
import language from '../utils/languages';
import { setFeedTopMargin } from '../utils/feedUtil';
import NoBookmarks from '../scenes/noBookmarks';
import MoengageService from '../services/moEngageService';
import { getCurrentLocation } from '../utils/textUtil';
import { screenNamesSet } from '../utils/screenUtils';
import { useLastLocation } from 'react-router-last-location';
import { getPreviousLocation } from '../utils/screenUtils';
import useReactRouter from 'use-react-router';
import { scrollToTop } from '../utils/postUtil';
import InfiniteScroll from 'react-infinite-scroll-component';

const Feed = ({
  feedStreamApi,
  showFab = true,
  screenName,
  tabTitle,
  isGetRequest = false,
  isUserProfile = false,
  isCourse,
  isMentor,
  isFriendList,
  match,
  isBookmark,
}) => {
  const setScrollPostId = useStoreActions(
    (actions) => actions.feed.setScrollPostId
  );
  const userFromMM = getThirdPartyUser();
  const webLanguage = getPostLanguage();
  const languageText = language[webLanguage ? webLanguage : 'en'];
  const enHiLang = webLanguage === 'en' || webLanguage === 'hi';
  // const loginSource = getLoginSource();
  // if (loginSource === 'paytm') {
  //   feedStreamApi = apiUrl.PAYTM_FETCH_FEED;
  // }
  const { setTabValue } = useStoreActions((actions) => actions.tab);
  if (screenName === 'Gww') {
    setTabValue(1);
  } else if (screenName === 'Social') {
    setTabValue(0);
  }
  const { history } = useReactRouter();
  const isChampion = getCurrentLocation[2] === 'champions';
  const spentTime = getSpentTime();
  const lastLocation = useLastLocation();
  const sourceName = getPreviousLocation(lastLocation);
  screenName === 'User Profile' &&
    MoengageService.trackScreenOpen(
      sourceName,
      !isChampion
        ? tabTitle === 'User-Profile-About'
          ? screenNamesSet.userProfileAbout
          : screenNamesSet.userProfileFeed
        : screenNamesSet.champions,
      spentTime
    );
  const isTablet = useTablet();
  const fetchFeed = useStoreActions((actions) => actions.feed.fetchFeed);

  let feedObj = useStoreState((state) => state.feed.feeds[feedStreamApi]); //globalState
  if (!feedObj) {
    feedObj = initFeed(createCellMeasurerCache); // Need the feed to be initialised first inorder to call the fetchFeed as the store for this feed is created in the fetchFeed.
  }
  const { docs, status } = feedObj;
  const scrollPosition = feedObj.scrollPosition;
  const handleLoadMore = () => {
    scrollPosition && setScrollPostId();
    fetchFeed({
      feedStreamApi,
      isGetRequest,
      createCellMeasurerCache,
      isCourse,
      isMentor,
      isBookmark,
    });
  };

  useEffect(() => {
    return () => {
      impressionService.fireEventsLeft();
    };
  }, []);
  useEffect(() => {
    status === '' && scrollToTop(); //added this, because by default course tab will open which is auto-scrolls to unwatched video (bottom-side), on feed also its scroller is at bottom side. So, user not able to see loader.
    docs.length > 0 ||
      (feedStreamApi &&
        fetchFeed({
          feedStreamApi,
          isGetRequest,
          createCellMeasurerCache,
          isCourse,
          isMentor,
          isBookmark,
        }));
  }, [
    status,
    docs.length,
    feedStreamApi,
    fetchFeed,
    isGetRequest,
    isCourse,
    isMentor,
    isBookmark,
  ]);

  const showCreatePostFabIcon =
    window?.location?.pathname.split('/')[1] === 'communities' ||
    window?.location?.pathname.split('/')[1] === 'users';
  const handleFabIcon = () => {
    history.push('/create-post', { communityObj: match?.params });
  };
  return (
    <Box
      mt={setFeedTopMargin({ userFromMM, isTablet, enHiLang })}
      height="90vh"
    >
      {status !== 'SUCCESS' && !docs.length && feedStreamApi ? (
        <Loader key={1} />
      ) : (
        docs?.map((doc, index) => {
          return <FeedCard key={index} postId={docs[index]} index={index} />;
        })
      )}
      {docs.length > 0 && (
        <InfiniteScroll
          dataLength={docs.length}
          next={handleLoadMore}
          hasMore={true}
        />
      )}
      {showFab ? (
        showCreatePostFabIcon ? (
          userFromMM === null && (
            <Box onClick={handleFabIcon}>
              <FabIcon />
            </Box>
          )
        ) : (
          <WomenWillDialogBox />
        )
      ) : (
        ''
      )}

      {status === 'SUCCESS' &&
        !docs.length &&
        !isUserProfile &&
        !isBookmark &&
        !isCourse &&
        !isFriendList && (
          <NotFound
            title="No Results Found"
            description={
              isGetRequest
                ? 'Please check spelling or try different keywords '
                : 'No posts found'
            }
            icon={NoResultsIcon}
          />
        )}
      {status === 'SUCCESS' && !docs.length && isBookmark && <NoBookmarks />}
      {status === 'SUCCESS' && !docs.length && isUserProfile && <NoPosts />}
      {status === 'SUCCESS' && !docs.length && isCourse && (
        <NullDataFound
          message={languageText?.YOUR_COURSE_PROGRESS_WILL_APPEAR_HERE}
          isIconShow={true}
          icon={FeelingHappy}
        />
      )}
      {status === 'SUCCESS' && !docs.length && isFriendList && (
        <NullDataFound message={'No Friends to show'} isIconShow={false} />
      )}
    </Box>
  );
};

function createCellMeasurerCache() {
  return new CellMeasurerCache({
    fixedWidth: true,
    defaultHeight: 300,
  });
}
export default Feed;
